<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tMsAYo/tc-custom/9781429936354.jpg?1722312903183" alt="This image is the cover for the book Eye of the Mountain God"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Eye of the Mountain God
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i><br/><br/></i></b><br/>Megan Montoya has come to New Mexico with her daughter, Lizzie, to begin a career in photography. One morning she opens her newspaper and five jagged stones clatter to the floor. A jeweler identifies them as emeralds, and an attractive archeologist believes they might be the legendary emerald arrowheads used by the Pima Indians four centuries ago to lure away the Spaniards. <br/><br/>Megan's paperboy goes missing, and her house is searched. Tension escalates as Megan finds her only client is hiding something, and that the man she is falling in love with may have ulterior motives. When Lizzie is kidnapped, Megan becomes embroiled in a separatist plot, bargaining with a cabal's crazed leader to spare her daughter's life.<br/><br/><i>Eye of the Mountain God</i> is Penny Rudolph's fourth crime novel. Combining a cast of maverick characters and nonstop action, she offers a unique and captivating story about one mother's love and the causes that some people are willing to die, and kill, for.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Penny Rudolph
      </h2>
      
      <p class="authorDescription body article"><P><B>Penny Rudolph</B> has worked as a bartender, truck driver, chile picker, musician, science writer, and medical writer. She's also taught journalism at New Mexico State University and won more than fifty national writing and editing awards, including an Eppie and an International Gold Quill. Penny lives in Albuquerque.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?301ca3ec